// 입금매칭·재고관리 이용 가능 플랜(스탠다드 이상). 체험판은 premium, 결제 실패(past_due)는
// 원래 유료 플랜 id를 가지므로 그대로 허용된다.
// 판정 재료는 subscription.subscription_plan_id — getCurrentPlan()은 조회 실패 시 'free'로
// 대체하므로 subscriptionPlan으로 판정하면 유료 셀러를 막을 수 있다.
export const isPaidPlanId = (planId: string | undefined) => planId === 'standard' || planId === 'premium';
